import { createMedia } from "@artsy/fresnel"
import {
  mobileBreakpoint,
  tabletBreakpoint,
  smallScreenBreakpoint,
  largeScreenBreakpoint
} from "../../theme/Theme__Responsive.bs"

const AppMedia = createMedia({
  breakpoints: {
    rbMobile: 0,
    rbTablet: mobileBreakpoint, // 425px
    rbSmallScreen: smallScreenBreakpoint, // 768px
    rbDesktop: tabletBreakpoint, // 1024x
    rbLargeDesktop: largeScreenBreakpoint //1288px
  },
})

// Make styles for injection into the header of the page
export const mediaStyles = AppMedia.createMediaStyle()

export const { Media, MediaContextProvider } = AppMedia